import { render } from "./InspectorDetailForm.vue?vue&type=template&id=e1d565f8"
import script from "./InspectorDetailForm.vue?vue&type=script&lang=js"
export * from "./InspectorDetailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__